import { Stack } from "@mui/material";
import ProductionTabs from "./tabs";

const Production = () => {
  return (
    <Stack maxWidth={{ xs: "100%", md: `calc(100vw - 316px)` }}>
      <ProductionTabs />
    </Stack>
  );
};

export default Production;
